import { Box, Typography } from "@mui/material";
import React from "react";
import { ReactComponent as UserIcon } from "../../../assets/svg/userRedirect.svg";
import { GRAY_SCALE } from "../../../theme/colors";
import { Link } from "react-router-dom";

const ButtonRedirect = (props) => {
  const { data } = props;
  return (
    <Link to={data?.url} style={{ textDecoration: "none" }}>
      <Box
        style={{
          border: "1px solid #DFE0EB",
          borderRadius: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: 30,
          cursor: "pointer",
        }}
        sx={{
          ":hover": {
            opacity: 0.8,
            backgroundColor: GRAY_SCALE,
          },
        }}
      >
        <UserIcon />
        <Typography variant="body2" className="mt-12">
          {data?.name}
        </Typography>
      </Box>
    </Link>
  );
};

export default ButtonRedirect;
